<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7LOZKT/tc-custom/9781504051675.jpg?1703427430319" alt="This image is the cover for the book Deep as the Marrow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deep as the Marrow
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times</i>–bestselling author of <i>The Select</i> “combines medical and political intrigue into one explosive, warp-speed thriller” (Douglas Preston).</b><br/>  <br/> To end the war on drugs, the president of the United States decides to legalize narcotics—and tax them heavily. Some think he’s crazy. Others want him dead.<br/>  <br/> The president’s personal physician, John Van Duyne, took an oath to do no harm, but after a Colombian drug lord kidnaps his six-year-old daughter, he’s forced to do the unthinkable to save her: poison the president.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        F. Paul Wilson
      </h2>
      
      <p class="authorDescription body article">F. Paul Wilson is the author of more than fifty books spanning various genres, including science fiction, horror, thriller, and more. Four of his novels have been <I>New York Times</I> bestsellers, and his work has earned him four Prometheus Awards, the prestigious Inkpot Award from the San Diego Comic-Con, and the Pioneer Award from the RT Booklovers Convention.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1fd7cd88